"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAGE_UNLOAD_TIME = exports.DEFAULT_MIN_TRY_COUNT = exports.MAX_DELAY_TIME = exports.DEFAULT_DELAY_TIME = void 0;
/**
 * 最小重试次数
 */
var DEFAULT_MIN_TRY_COUNT = 1;
exports.DEFAULT_MIN_TRY_COUNT = DEFAULT_MIN_TRY_COUNT;
/**
* 默认重连时间
*/
var DEFAULT_DELAY_TIME = 0;
exports.DEFAULT_DELAY_TIME = DEFAULT_DELAY_TIME;
/**
 * 页面关闭断连重连时间间隔
 */
var PAGE_UNLOAD_TIME = 3 * 1000;
exports.PAGE_UNLOAD_TIME = PAGE_UNLOAD_TIME;
/**
* 超过三次后最大重试时间间隔
*/
var MAX_DELAY_TIME = 30 * 1000;
exports.MAX_DELAY_TIME = MAX_DELAY_TIME;
